import { Realty, services } from '@ambita/ambita-components-core';

const util = services.util;

function transformSeparatelyOccupiedUnits(unitsData: Realty.ApiResponse) {
  if (unitsData.items && unitsData.items.length > 0) {
    const units: Realty.ApiSeparatelyOccupiedUnit[] = unitsData.items;
    const retObject: any = {
      separatelyOccupiedUnits: []
    };

    units.forEach((unit: Realty.ApiSeparatelyOccupiedUnit) => {
      const tmpObj: any = util.pick(unit, [
        'floorNumber',
        'kitchenAccessCode',
        'links',
        'numberOfRooms',
        'numberOfBathRooms',
        'numberOfWCs',
        'unitNumber',
        'unitType',
        'usableArea'
      ]);
      retObject.separatelyOccupiedUnits.push(tmpObj);
    });
    return retObject;
  }
}

export default transformSeparatelyOccupiedUnits;
